import { render, staticRenderFns } from "./ShortListCandidates.vue?vue&type=template&id=1c8a28dd&scoped=true"
import script from "./ShortListCandidates.vue?vue&type=script&lang=js"
export * from "./ShortListCandidates.vue?vue&type=script&lang=js"
import style0 from "./ShortListCandidates.vue?vue&type=style&index=0&id=1c8a28dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a28dd",
  null
  
)

export default component.exports